import React, { createContext, useContext, useReducer } from "react";
import { initialState, obrasReducer, ObrasState } from "./obras-reducer";

type ObrasContextType = {
    state: ObrasState;
    dispatch: React.Dispatch<any>;
};

const ObrasContext = createContext<ObrasContextType | undefined>(undefined);

export const ObrasProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(obrasReducer, initialState);

    return (
        <ObrasContext.Provider value={{ state, dispatch }}>
            {children}
        </ObrasContext.Provider>
    );
};

export const useObrasState = () => {
    const context = useContext(ObrasContext);
    if (!context) {
        throw new Error("useObrasState must be used within ObrasProvider");
    }
    return context.state;
};

export const useObrasDispatch = () => {
    const context = useContext(ObrasContext);
    if (!context) {
        throw new Error("useObrasDispatch must be used within ObrasProvider");
    }
    return context.dispatch;
};
